import { render } from "./InvoicePage2.vue?vue&type=template&id=6f8fe7a8&scoped=true"
import script from "./InvoicePage2.vue?vue&type=script&lang=js"
export * from "./InvoicePage2.vue?vue&type=script&lang=js"

import "./InvoicePage2.vue?vue&type=style&index=0&id=6f8fe7a8&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-6f8fe7a8"

export default script